
export const SECONDARY_CHECKOUT_BUTTON_CLASSES = [
  'block w-full py-2 mt-4',
  'text-brand-dark bg-gray-200 text-xl',
  'border border-gray-300 cursor-pointer hover:bg-opacity-60',
  'transition transition-opacity duration-300'
];

export const BUTTON_LOGOS = {
  paypal: "/img/badges/paypal_200.png",
  affirm: "/img/badges/affirm_200_black.png"
}
